module.exports = __webpack_public_path__ + "img/bg-014-green.a3dd2075.jpg";